if (!customElements.get('scroll-to-top-button')) {
  class ScrollToTopButton extends HTMLElement {
    constructor() {
      super();

      this.updateRevealState = this.updateRevealState.bind(this);

      this.updateRevealState();

      window.addEventListener('scroll', () => {
        requestAnimationFrame(this.updateRevealState);
      }, { passive: true });

      this.addEventListener('click', () => {
        this.scrollToTop();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.scrollToTop();
        }
      });
    }

    updateRevealState() {
      const isVisible = window.scrollY > window.innerHeight;
      this.classList.toggle('reveal', isVisible);
      document.body.classList.toggle('scroll-to-top-visible', isVisible);
    }

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      setTimeout(() => {
        document.querySelector('.skip-to-content-link')?.focus();
      }, 700);
    }
  }

  customElements.define('scroll-to-top-button', ScrollToTopButton);
}
